import { escapeSqlSingleQuote } from './escapeSqlSingleQuote';

/**
 * Creates an inline mapping subquery that can be selected from and joined with like a reference table.
 * @param referenceValues - The values to 'insert'.
 * @param keys - the keys of any fields in the reference value object to 'insert'.
 * @param mappingOverride - (optional) override for providing a mapping name and key aliases
 * @returns A subquery string in the format (SELECT * FROM (VALUES ...)) AS <mappingName(...keys)>)
 */
export const createInlineMappingSubquery = (
  referenceValues: object[] | undefined,
  keys: string[],
  mappingOverride?: string
) => {
  // Build VALUES rows like [('id1', 'val1'), ('id2', 'val2'), ...]
  const values = (referenceValues || [])
    .map((v) => {
      const values = keys
        .map((k) => quoteStringValue(v[k as keyof typeof v]))
        .join(', ');
      return `(${values})`;
    })
    .join(', ');

  const subquery = `(SELECT * FROM (VALUES ${values}) AS
    ${mappingOverride ?? `mapping(${keys.join(', ')})`})`;

  console.debug('subquery', subquery);

  return subquery;
};

const quoteStringValue = (s: unknown) =>
  typeof s === 'string' ? `'${escapeSqlSingleQuote(s)}'` : s;
